import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ScrollLock from 'react-scrolllock';

import Menu from 'react-burger-menu/lib/menus/slide';
import Link from 'gatsby-link';

import './MobileNavigation.module.css';

import CloseIcon from 'Assets/images/icon_close.svg'

class MobileNavigation extends Component {

  state = {
    fixedNavigation: false,
    menuOpen: false
  };

  static propTypes = {
    data: PropTypes.object,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (event) => {
    this.setState({
      fixedNavigation: window.scrollY > 22
    });
  };

  handleStateChange (state) {
    this.setState({
      menuOpen: state.isOpen
    })
  }

  hideMenu = () => {
    this.setState({
      menuOpen: false
    });
  }

  render () {
    const { data } = this.props;
    return (
      <div className={this.state.fixedNavigation ? 'fixed' : ''}>
        <Menu right styleName="mobileMenu"
              isOpen={this.state.menuOpen}
              customCrossIcon={ <img src={CloseIcon} style={{minWidth: 30, minHeight: 30}} /> }
              onStateChange={(state) => this.handleStateChange(state)}>
          <ul ref={list => { this.list = list }}>
            {
              data.navigation.map((item) => (
                <li key={item.navigation.target}>
                  <a href={`#${item.navigation.target}`} onClick={this.hideMenu}>
                    { item.navigation.name }
                  </a>
                </li>
              ))
            }
          </ul>
        </Menu>
        { this.state.menuOpen && <ScrollLock touchScrollTarget={this.list} /> }
      </div>
    );
  }
}

export default MobileNavigation;


// WEBPACK FOOTER //
// ./src/components/Header/MobileNavigation.js